import { render, staticRenderFns } from "./LdVerifyEmailModal.vue?vue&type=template&id=5ed90140"
import script from "./LdVerifyEmailModal.vue?vue&type=script&lang=js"
export * from "./LdVerifyEmailModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports